import React from "react";
import MeetingList from "../../../components/adm/meeting/meetingFilterList";
import Layout from "../../../components/layouts/verticalLayout";

const MeetingListPage = (props) => {
  return <Layout body={<MeetingList />} />;
};

MeetingListPage.propTypes = {};

export default MeetingListPage;
